import { render, staticRenderFns } from "./ProfileChangeEmail.vue?vue&type=template&id=42666c8a&scoped=true"
import script from "./ProfileChangeEmail.vue?vue&type=script&lang=js"
export * from "./ProfileChangeEmail.vue?vue&type=script&lang=js"
import style0 from "./ProfileChangeEmail.vue?vue&type=style&index=0&id=42666c8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42666c8a",
  null
  
)

export default component.exports